import { Box, Card, Grid, Typography } from "@material-ui/core";
import { LoadingWidget } from "Components/index";
import { lazy, Suspense } from "react";
import { getUserRole } from "src/utils";
import useStyles from "./styles";
const Departments = lazy(() => import("./Common/Departments"));
const Locations = lazy(() => import("./Common/Locations"));
const Message = lazy(() => import("./Common/Message"));
const OnBoardingQuestions = lazy(() => import("./Common/OnboardingQuestions"));
const PasswordComplexity = lazy(() =>
  import("./Common/PasswordComplexity/PasswordComplexity")
);
const PerformaceCycle = lazy(() => import("./Common/PerformanceCycle"));
const Titles = lazy(() => import("./Common/Titles"));

const Configuration = () => {
  const classes = useStyles();

  return (
    <Card className={classes.companySettingForm}>
      <Typography variant="h4" className="font-20 font-semibold">
        Configuration
      </Typography>
      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" pageLoader={true} />
          </div>
        }
      >
      <Box mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} className={classes.msgField}>
            <Message />
          </Grid>
          <Grid item xs={12} sm={6}>
            <PasswordComplexity />
          </Grid>
          <Grid item xs={12}>
            <Titles />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Locations />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Departments />
          </Grid>
          <Grid item xs={12}>
            <OnBoardingQuestions />
          </Grid>
          {getUserRole() === "CompanyAdmin" ? (
            <Grid item xs={12}>
              <PerformaceCycle />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      </Suspense>
    </Card>
  );
};

export default Configuration;
